export const GAME_PAGE_TITLE_GOLD = 'text-[hsl(43,72%,55%)]';

const SIZE = 'min-w-0 font-heading text-xl font-black sm:text-2xl md:text-3xl';

export const gamePageTitleH1Class = `${SIZE} text-left uppercase tracking-[0.12em] sm:tracking-[0.18em] ${GAME_PAGE_TITLE_GOLD}`;

export const gamePageTitleH1ClassCenter = `${SIZE} text-center uppercase tracking-[0.12em] sm:tracking-[0.18em] ${GAME_PAGE_TITLE_GOLD}`;

export const gamePageHeroTitleClass = `${SIZE} text-center tracking-wide normal-case ${GAME_PAGE_TITLE_GOLD}`;

const BODY = 'font-[family-name:var(--font-body)]';

export const gamePagePlayerTypedBodyCaseClass = `${BODY} normal-case`;

export const gamePagePlayerTypedHeroClass = `min-w-0 text-center text-xl font-semibold normal-case tracking-normal sm:text-2xl md:text-3xl ${BODY} ${GAME_PAGE_TITLE_GOLD}`;

export const gamePagePlayerTypedHeroClassLeft = `min-w-0 text-left text-xl font-semibold normal-case tracking-normal sm:text-2xl md:text-3xl ${BODY} ${GAME_PAGE_TITLE_GOLD}`;

export const gamePagePlayerTypedHeadingClass = `font-semibold normal-case tracking-normal text-xl drop-shadow-lg sm:text-2xl ${BODY} ${GAME_PAGE_TITLE_GOLD}`;

export const gamePagePlayerTypedShipBannerClass = `${BODY} font-bold normal-case break-words text-yellow-400`;
